<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Операция с членством,  пакетом услуг</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Операция с членством,  пакетом услуг</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <v-form ref="addClientForm" @submit.prevent="submitFreezeStatus">
                  <div class="column" style="padding: 20px 20px 0 20px !important;">
                    <v-row>
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Клиент</label>
                        <div class="d-flex" style="align-items: center">
                          {{ visitorDesktop.client.name}}
                        </div>
                      </v-col>
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Операция</label>
                        <v-select
                            class="rounded-lg custom__select"
                            :items="operations"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            item-text="name"
                            item-value="link"
                            v-model="operation"
                            label="Выбрать"
                            append-icon="mdi-chevron-down"
                            :background-color="getBgColor(operation)"
                            color="#629f34"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 5px; margin-bottom: 0 !important;"
                        >
                          <template v-slot:item=" { item } ">
                            <router-link :to="{ name: item.link, params: {client_id: client_id, product_id: product_id}}" style="text-decoration: none; color: #000">
                              {{ item.name }}
                            </router-link>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="!add_days">
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Членство, пакет услуг</label>
                       <v-select
                            v-if="visitorDesktop"
                            :items="visitorDesktop.client.productes"
                            item-value="product_id"
                            item-text="product_name"
                            v-model="product_id"
                            class="rounded-lg"
                            append-icon="mdi-chevron-down"
                            hide-details
                            outlined
                            dense
                            background-color="white"
                            style="height: 48px;padding-top: 5px; flex: none !important;"
                        >
                        </v-select>
                      </v-col>
                      <v-col
                          md="2"
                          sm="12"
                      >
                        <label>С</label>
                        <VueDatePicker
                            format="YYYY-MM-DD"
                            :rules="dateFromRules"
                            no-title
                            no-header
                            color="#629f34"
                            v-model="dateFrom"
                            placeholder="Дата"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="dateFrom">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                      </v-col>
                      <v-col
                          md="2"
                          sm="12"
                      >
                        <label>На срок дней</label>
                        <v-text-field
                            v-if="freezeList.data.data.balance && freezeList.data.data.balance > 0"
                            v-model="days"
                            :rules="daysRules"
                            placeholder="0"
                            outlined
                            dense
                            style="height: 48px;margin-top: 5px"
                            class="rounded-lg"
                            @keyup="keyUpdays"
                        ></v-text-field>
                        <v-text-field
                            v-else
                            v-model="days"
                            :rules="daysRules"
                            placeholder="0"
                            outlined
                            dense
                            style="height: 48px;margin-top: 5px"
                            class="rounded-lg"
                            readonly
                        ></v-text-field>
                      </v-col>
                      <v-col
                          md="2"
                          sm="12"
                      >
                        <label>До</label>
                        <VueDatePicker
                          v-if="freezeList.data.data.balance && freezeList.data.data.balance > 0"
                            no-title
                            no-header
                            format="YYYY-MM-DD"
                            :rules="daysRules"
                            color="#629f34"
                            v-model="dateTo"
                            placeholder="Дата"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="dateTo">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                        <VueDatePicker
                          v-else
                            no-title
                            no-header
                            format="YYYY-MM-DD"
                            :rules="daysRules"
                            color="#629f34"
                            v-model="dateTo"
                            placeholder="Дата"
                            readonly
                            disabled
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="dateTo">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                      </v-col>
                    </v-row>
                    <v-row v-if="!add_days">
                      <v-col
                        md="6"
                        style="padding: 0 16px 20px 16px !important;"
                      >
                        <div class="hint">
                          Использовано заморозок на: {{freezeList.data.data.used || 0}} {{ getRightDay(freezeList.data.data.used) }}. Доступно заморозок на: {{freezeList.data.data.balance || 0}} {{ getRightDay(freezeList.data.data.balance) }}. Минимальный срок: {{freezeList.data.data.minimum || 0}} {{ getRightDay(freezeList.data.data.minimum) }}.
                        </div>
                      </v-col>
                      <v-col
                        md="6"
                        style="padding: 0 16px 20px 16px !important;"
                      >
                        <div class="hint">
                          Используется для временного прекращения действия членства (пакеты услуг). Срок
                          действия членства (пакеты услуг) увеличивается на срок заморозки.
                        </div>
                      </v-col>
                    </v-row>

                    <v-row v-if="add_days">
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Членство, пакет услуг</label>
                       <v-select
                            v-if="visitorDesktop"
                            :items="visitorDesktop.client.productes"
                            item-value="product_id"
                            item-text="product_name"
                            v-model="product_id"
                            class="rounded-lg"
                            append-icon="mdi-chevron-down"
                            hide-details
                            outlined
                            dense
                            background-color="white"
                            style="height: 48px;padding-top: 5px; flex: none !important;"
                        >
                        </v-select>
                      </v-col>

                      <v-col
                            md="6"
                            sm="12"
                        >
                          <label v-if="modifierList && modifierList.data && modifierList.data.length > 0">Модификатор</label>
                          <label v-else>Модификатор (загрузка...)</label>
                          <v-select
                              v-if="modifierList && modifierList.data"
                              :items="modifierList.data"
                              v-model="modifier_id"
                              item-value="id"
                              item-text="name"
                              :rules="modifierRules"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              background-color="white"
                              return-object
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          <v-select
                              v-else
                              :items="modifierNomenclatureDef"
                              v-model="modifier_id_def"
                              item-value="id"
                              item-text="name"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              background-color="white"
                              return-object
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          
                        </v-col>

           

                    </v-row>

                    <v-row v-if="add_days" style="justify-content: space-between;">
                      <v-col
                          md="2"
                          sm="12"
                      >
                        <label>Количество дней: </label>
                        <v-text-field
                            v-model="adding_days"
                            :rules="daysRules"
                            placeholder="0"
                            outlined
                            dense
                            style="height: 48px;margin-top: 5px"
                            class="rounded-lg"
                        ></v-text-field>
                    
                      </v-col>

                      <v-col
                          md="2"
                          sm="12"
                      >
                          <div v-if="modifier_id && modifier_id.free === false" style="">Цена: {{ modifier_id.price }} </div>
                          <div v-else-if="modifier_id" style="">Цена: бесплатно </div>
                    </v-col>

                    </v-row>

                  </div>

                    <div class="column" v-if="!add_days">
                      <v-data-table
                          v-model="selectProduct"
                          :headers="headersProductes"
                          :items="freezeList.data.data.documents"
                          :hide-default-footer="true"
                          no-data-text="Нет членства (пакеты услуг)"
                          item-key="name"
                          class="elevation-1 mt-3 rounded-b-0 custom__table"
                      >


                      </v-data-table>
                    </div>
                  <div class="column d-flex justify-space-between" style="padding: 20px !important;">
                    <v-btn
                        v-if="document_id" @click="removeDocument"
                              class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>
                    <div>
                      <v-btn
                          :to="{ name: 'SaleHistory', params: {client_id: client_id} }"
                          class="button__lighten ml-3"
                      >
                        <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                        История
                      </v-btn>
                    </div>
                    <div>
                      <v-btn :disabled="isLoading" v-if="!add_days" class="button__success" type="submit">
                        Заморозить
                      </v-btn>

                      <v-btn :disabled="isLoading" v-if="add_days && modifier_id && (adding_days > 0)" class="button__success" type="submit">
                        Добавить
                      </v-btn>
                      <v-btn :disabled="isLoading" v-else-if="add_days" class="button__secondary__text" type="submit">
                        Добавить
                      </v-btn>

                    </div>
                  </div>
                  </v-form>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>

        <v-row justify="center">
              <v-dialog
                  v-model="dialogDelete"
                  persistent
                  max-width="400px"
              >
                <v-form @submit.prevent="removeDocumentSubmit">
                  <v-card>
                    <v-card-title class="text-center">
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialogDelete = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 30px;">
                      <v-container>
                        <div>
                          <h3 class="card-title">Вы уверены, что хотите удалить выбранный объект?</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5 justify-center"
                        >
                          <button
                              class="button button__danger"
                              ref="activator"
                              type="submit"
                          >
                            Да
                          </button>
                          <button
                              class="button button__unlock ml-5"
                              ref="activator"
                              type="button"
                              @click="dialogDelete = false"
                          >
                            Нет
                          </button>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>


      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import {clientActionTypes} from '@/store/modules/client';
import {receptionActionTypes} from '@/store/modules/reception';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";
export default {
  name: "FreezePackage",
  props: ['client_id','product_id','add_days','freezedays','document_id'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      listAllClient: state => state.client.listAllClient,
      visitorDesktop: state => state.reception.visitorDesktop,
      freezeList: state => state.client.freezeList,
      validationErrors: state => state.client.validationErrors,
      modifierList: state => state.client.modifierList
    }),
    searchClients() {
      return this.listAllClient.client.filter((i) => {
        return !this.search || (i.name.toLowerCase().includes(this.search.toLowerCase()));
      })
    },
    searchPackages() {
      return this.visitorDesktop.client.productes.filter((i) => {
        return !this.searchPackages || (i.name.toLowerCase().includes(this.searchPackages.toLowerCase()));
      })
    }
  },
  data () {
    return {
      search: '',
      searchPackage: '',
      dateFrom:  new Date().toISOString().slice(0, 10),
      dateTo: null,
      selectProduct: null,
      days: null,
      operations: [
        {name: 'Заморозка', link: 'FreezePackage'},
        {name: 'Разморозка', link: 'UnfreezePackage'},
        {name: 'Смена владельца', link: 'ChangeOwner'}
      ],
      operation: 'FreezePackage',
      headersProductes: [
        {text: 'Дата', value: 'date'},
        {text: 'Документы', value: 'document.name'},
        {text: 'Дата c', value: 'startdate'},
        {text: 'Дата до', value: 'enddate'},
        {text: 'Дней', value: 'days'},
      ],

      name:null,
      daysRules: [
        v => !!v || 'Кол-во дней обязательное поле'
      ],
      dateFromRules: [
        v => !!v || 'Дата начала обязательное поле'
      ],
      adding_days:0,
      modifier_id:null,
      dialogDelete:false
    }
  },
  methods: {
    removeDocumentSubmit(){
      this.$store.dispatch(receptionActionTypes.documentRemove, {
        document_id: this.document_id
      })
      .then(() => {
        this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });
        this.dialogDelete = false;
      })
    },
    removeDocument(){
      this.dialogDelete = true;
    },
    getRightDay(number){
      if (number > 10 && [11, 12, 13, 14].includes(number%100)) return 'дней';
      let last_num = number%10;
      if (last_num == 1) return 'день';
      if ([2,3,4].includes(last_num)) return 'дня';
      if ([5,6,7,8,9, 0].includes(last_num)) return 'дней';

      return 'дней'
    },
    keyUpdays() {
      if (this.dateFrom !== null) {
        var someDate = new Date(this.dateFrom);
        var duration = this.days
        someDate.setTime(someDate.getTime() +  (duration * 24 * 60 * 60 * 1000))

        console.log('keyupdats')
        this.dateTo = someDate
      }
    },
    submitFreezeStatus() {

      if(this.add_days) {

            this.$store.dispatch(clientActionTypes.setFreezeStatus, {
                client_id: this.client_id,
                product_id: this.product_id,
                modifier_id:this.modifier_id.id,
                days: this.adding_days,
                add_days: true
            })
            .then(() => {
                this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
              });
            })

      } else {
        if (this.$refs.addClientForm.validate()) {
          
          if(this.freezeList.data.data.minimum > this.days){
            let ss = 'Минимальное кол-во дней заморозки: ' + this.freezeList.data.data.minimum
            alert(ss)
            return
          }

          if(this.freezeList.data.data.balance < this.days){
            let ss = 'Максимальное доступное кол-во дней заморозки: ' + this.freezeList.data.data.balance
            alert(ss)
            return
          }

          this.$store.dispatch(clientActionTypes.setFreezeStatus, {
            client_id: this.client_id,
            product_id: this.product_id,
            date: this.dateFrom,
            days: this.days

          })
              .then(() => {
                this.fetchFeed(this.client_id,this.product_id);
                this.$router.push({
                name: 'Desktop',
                params: {
                  client_id: this.client_id
                }
              });
              })
        }
      }
    },
    fetchFeed(client_id,product_id) {
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id})
      this.$store.dispatch(clientActionTypes.getFreezeList,{client_id: client_id,product_id: product_id});
    },
    getBgColor(operation) {
      if (operation === 'FreezePackage') {
        return '#FBEBEA';
      } else if (operation === 'UnfreezePackage') {
        return '#E0ECD6';
      } else {
        return '#FFF8E6';
      }
    }
  },
  mounted() {
    this.client_id !== undefined ? setItem('freeze-client_id', this.client_id) : this.client_id = getItem('freeze-client_id');
    this.product_id !== undefined ? setItem('freeze-product_id', this.product_id) : this.product_id = getItem('freeze-product_id');

    if(this.add_days){
      this.operations.push({name: 'Добавление дней заморозки', link: 'FreezePackageDays'})
      this.operation = 'FreezePackageDays'

      this.$store.dispatch(clientActionTypes.getModifierList, {
          client_id: this.client_id,
          modifier_type: "СрокЗаморозки"
        })
        .then((res) => {
          console.log(res)
          if(res && res.data){
            // let settedModifier = res.data[0]
            // settedModifier.price = 0
            // this.modifier_id = settedModifier
          }
        })

    }

    if(this.freezedays) {
      this.adding_days = this.freezedays
      this.days = this.freezedays
    }

    this.fetchFeed(this.client_id,this.product_id);
  },
  watch: {
    dateFrom(){
      
      if (this.dateFrom !== null && this.dateTo !== null) {
        let decrSum = new Date(this.dateTo).getTime() - new Date(this.dateFrom).getTime()
        if(decrSum > 0){
          this.days = Math.trunc(decrSum/(60*60*24*100*10))
        } else {
          this.days = 0
        }
      }
    },
    dateTo(){
      console.log(this.dateFrom)
      if (this.dateFrom !== null && this.dateTo !== null) {
        let decrSum = new Date(this.dateTo).getTime() - new Date(this.dateFrom).getTime()
        console.log(decrSum)
        if(decrSum > 0){
          this.days = Math.trunc(decrSum/(60*60*24*100*10))
        } else {
          this.days = 0
        }
      }
    },
    product_id(){
      this.fetchFeed(this.client_id,this.product_id);
    },
    operation(){
      if(this.operation === 'ChangeOwner'){
            this.$router.push({
              name: 'ChangeOwner',
              params: {
                client_id: this.client_id,
                product_id: this.product_id
              }
            });
      }
    },
    modifier_id (){
      this.adding_days = this.modifier_id.fix

    }
  },

}
</script>

<style scoped>
.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 5px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
.hint {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #767676;
}
</style>